import { format } from "date-fns";
export class PAReviewItemDetailModel {
    constructor() {
        this.reviewCycleName = "";
        this.employeeName = "";
        this.employeeDesignation = "";
        this.profileImageURL = "";
        this.status = "";
        this.period = "";
        this.isMakeClientAssignment = false;
        this.isReviewClientAssignable = false;
        this.isReviewPromotable = false;
        this.isReviewRejectable = false;
        this.isReviewDeliverable = false;
        this.isReviewDownloadable = false;
        this.isReviewReadOnly = false;
        this.noActionsToTake = false;
        this.isDeliverablePostClientAssignment = false;
        this.previousReviewId = null;
        this.nextReviewId = null;
    }
    formattedDate() {
        if (!this.reviewStartDate && !this.reviewEndDate) {
            return "";
        }
        const startDateFormatted = format(new Date(this.reviewStartDate), "MMM d, yyyy");
        const endDateFormatted = format(new Date(this.reviewEndDate), "MMM d, yyyy");
        return `${startDateFormatted} - ${endDateFormatted}`;
    }
}
export default class PAReviewItemDetail extends PAReviewItemDetailModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
